import { gatewaySectorWorkFlows } from "../../../../../../../../../gateways/gatewaySectorWorkFlows";

export const getAreas = async ({ categoryUid, squareFt }) => {
  const res = await gatewaySectorWorkFlows.get(`/areas?category=${categoryUid}&squareFootage=${squareFt}`);
  return res.data?.data || res.data;
};
